import React, { lazy, Suspense, useEffect, useState } from 'react';
const App = lazy(() => import('../App'));
const PublicSurvey = lazy(() => import('./PublicSurvey'));
export default function SurveyEntry() {
    const [hash, setHash] = useState(window.location.hash);
    useEffect(() => {
        const changed = () => setHash(window.location.hash);
        window.addEventListener('hashchange', changed);
        return () => window.removeEventListener('hashchange', changed);
    }, []);
    const match = hash.match(/^#\/encuesta\/([a-f0-9]{48})$/);
    return <Suspense fallback={<div role="status">Cargando…</div>}>{match ? <PublicSurvey key={match[1]} token={match[1]} /> : <App />}</Suspense>;
}
